<template>
  <div class="scale-dialog">
      <el-dialog v-model="dialogTableVisible" title="称重去皮" width="35%" center @close="close">
      <!-- 拍照 -->
      <!-- <camera ref="cameraRef" :addImageUrl="imgUrl" @getImgUrl="getImgUrl"></camera> -->
        <!-- 去皮选项卡 -->
        <el-space wrap  style="width: 100%" v-if="isWeight">
          <div class="tabs-item" v-for="(item, index) in currentTab" :key="index" :class="{active: index === currentIndex}" @click="handleClick(index)">{{item}}</div>
        </el-space>
        <el-form :model="form" label-width="auto" style="margin-top: 20px;">
          <el-form-item label="当前去皮:" v-if="isWeight">
            <el-input v-model="form.peel"  style="width: 55%;" @focus="inputFocus('peel')" class="custom-input" @change="peelChange"  size="enum" :readonly="currentIndex!==tabList.length-1" >
              <template #append>公斤</template>
            </el-input>
          </el-form-item>
          <el-form-item :label="`${warehouseType==1?'出仓':warehouseType==2?'回仓':warehouseType==3||warehouseType==4?'交货':'入仓'}重量:`">
            <div class="flex" style="width:100%">
            <el-input v-model="form.weigth" :class="{'custom-input':!isWeight}" @change="splitWeigthChange" @focus="inputFocus('weigth')" style="width: 55%;margin-right:15px"  size="enum"  :disabled="isWeight">
               <template #append>{{isWeight?'公斤':currentData.unitName||''}}</template>
              </el-input>
              <el-checkbox v-if="!warehouseType||warehouseType==2" v-model="form.checked"  :label="`${warehouseType==2&&isWeight?'已加工':warehouseType==2&&!isWeight?'已拆封':warehouseType==0?'直接出仓':''}`" size="enum" />
              <el-input v-if="warehouseType==2&&!isWeight&&form.checked" @focus="inputFocus('splitWeigth')" v-model="form.splitWeigth" @change="splitWeigthChange" :class="{'custom-input':!isWeight}" style="width: 55%;margin-left:15px"  size="enum" >
               <template #append>{{isWeight?'公斤':currentData.unitName||''}}</template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="出仓单:" v-if="warehouseType==1&&currentData.infoList">
            <el-checkbox-group v-model="form.checkList" size="enum">
              <!-- goodsIsSeasoning  1 调料 0 非调料-->
              <el-checkbox :label="item.reduceInfoId"  :value="item.reduceInfoId"  v-for="(item, index) in currentData.infoList" :key="index" >
               {{isWeight?GetNumByUnit(item.orderNo,'g','kg')+"kg":`${item.unitOrderNo}${getUnitLabel(item.unit)}`}}
               <span v-if="!isWeight&&!getUnitLabel(item.unit,true)">{{getDictUnit(unitSplic(item.specFullName,true),item.orderNo)}}</span>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="计划量:" v-if="warehouseType==4">
            <el-checkbox-group v-model="form.checkList" size="enum">
              <el-checkbox :label="item.processOrderId"  :value="item.processOrderId" v-for="(item, index) in currentData.infoList" :key="index" >
                {{GetNumByUnit(item.goodsSuttleWeight,'g','kg')}}kg{{`(${item.orderTypeName})`}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

        <!-- 键盘 -->
        <number-keyboard style="width:100%" 
        @onChange="onChange" ref="keyboardRef"
        @onKeyPress="onkeyPress"
        :layout="keyboardLayout"
        :keyboardSetOpen="keyboardSetOpen"
        :input="form[currentKey]"
      ></number-keyboard>

  </el-dialog>
  </div>
</template>
<script lang="ts" setup>
import { reactive, ref } from 'vue'
import numberKeyboard from "../../components/numberKeyboard.vue";
import delIcon from "../../assets/del.png";
// import camera from "../../components/Camera.vue";
import { ElMessage, ElMessageBox } from 'element-plus'
import { GetNumByUnit, toFixedDigit } from "@/utils/uni.js";
import { dict } from "@/utils/getDict";
import { getUserConfigValue } from "@/api/setting.js";
import { uploadStaffPic } from "@/utils/dataURLtoFile";
import { getCurrentInstance } from 'vue';

const proxy = getCurrentInstance();
const dialogTableVisible = ref(false)
const $emit = defineEmits(['onSubmit'])
// 表单数据
const form=ref({
    weigth: 0,
    peel: 0,
    addImage: '',
    checked: false,
    returnImage:''
})
// 定时器
let setTiem: any = null;
// 拍照
// const cameraRef = ref(null)
// 键盘
const keyboardRef = ref(null)
// 图片地址
const imgUrl = ref('')
// 键盘配置
let keyboardLayout={
        default:[
          "1 2 3 {bksp}",
          "4 5 6 {clear}",
          "7 8 9 {husk}",
          ". 0 {close} {enter}",
          // "{close} 0 {abc} {enter}",
        ]
}
// 键盘配送 中文语言
let keyboardSetOpen={
      "{enter}": "确认",
      "{123}": "123",
      "{clear}": "清空",
      "{husk}": "重置去皮",
      "{bksp}": `<img src=${delIcon} style='' width='30'>`,
      "{close}": "取消",
}
// 当前键盘输入的key
let currentKey = ref('peel')
// 当前选选中数据
let currentData = ref(null)


// 是否显示计重
const isWeight = ref(false)

// 选项卡
const tabList=['无', '黑色框','蓝色框','红色框','黄色框','青色框','紫色框','绿色框','自定义']
// 当前显示的选项卡
const currentTab = ref(tabList)
// 当前
let currentIndex = ref(0)
// 当前弹框是出仓还是入仓或退仓
let warehouseType = ref(0)
// 字典数据
let dictObj = ref({})
const dictsFun = async () => {
  dictObj.value = await dict(
    ["all_unit_type"],
    dictObj.value
  );
}
dictsFun()
// 选项卡点击

const handleClick = (index: number) => {
  currentIndex.value = index
  form.value['peel'] = ''

  // 清空键盘之前的输入值
  keyboardRef.value.resetKeyboard('')

  const val=script.setEnumu(index,0)||0
  form.value['peel']=val
  
}
// 自定义输入去皮量
const peelChange=(e:any)=>{
  if(currentIndex.value==8){
   let evetn= Number(e)
    const val=script.setEnumu(8,evetn)||0
    form.value['peel'] = val
    form.value['weigth'] = form.value['weigth'] - evetn
  }
}

// 打开弹框
const open = (data: any,type:number,isFig:boolean) => {
  clearData()
  getCustomContainer()
  
  warehouseType.value = type
  if(data&&data.infoList&&data.infoList.length>0){
    form.value['checkList'] = data.infoList.map(item=>item.reduceInfoId||item.processOrderId)
  }
  currentData.value = data

  isWeight.value=isFig
  dialogTableVisible.value = true

  currentKey.value = isFig?'peel':'weigth'

  // let val=script.setEnumu('0',0)||0
  form.value['peel'] = 0
  // 开启监听
  script.startSerialPortListerning()
  if(!isFig)return
  
  getWeight()
  
}
// 拍照图片
const getImgUrl = (url: string) => {
  imgUrl.value = url
  if(warehouseType.value==2){//判断如果是退仓，则将图片赋值给returnImage
    form.value.returnImage = url
    return 
  }
  form.value.addImage = url

}
// 拆分输入
const splitWeigthChange=(e)=>{
if(form.value.weigth<form.value.splitWeigth){
  form.value.splitWeigth = form.value.weigth
}
if(currentKey.value=='splitWeigth'){
    keyboardRef.value.resetKeyboard(form.value.splitWeigth)
  }
}
// 输入框获取焦点
const inputFocus = (key: string) => {
  currentKey.value = key
 
}

// 键盘输入
const onChange = (value: string) => {
  if(!isWeight.value){//如果不是计重，则直接赋值
    form.value[currentKey.value] = value
    splitWeigthChange()
    return
  }
  
  if (currentIndex.value !== tabList.length - 1) return
  form.value['peel'] = value
}
// 键盘按键
const onkeyPress =async (key: string) => {
  const msg=warehouseType.value==1?'出仓':warehouseType.value==2?'回仓':warehouseType.value==3||warehouseType.value==4?'交货':'入仓'
  
  if (key === '{enter}') {//键盘确认
      try{
         // 确认摄像头拍照
        // await cameraRef.value.shoot();
        const imageData = await proxy.appContext.config.globalProperties.$takePhoto()
        // 上传图片
        const imgData = await uploadStaffPic("file/upload", imageData.replace(/[\r\n]/g, ""), ".png");
        imgUrl.value = imgData.url
        if(warehouseType.value==2){//判断如果是退仓，则将图片赋值给returnImage
          form.value.returnImage = imgData.url
          return 
        }
        form.value.addImage = imgData.url
        const obj=Object.assign({},currentData.value,form.value)
          if(currentData.value&&currentData.value.infoList&&currentData.value.infoList.length>0&&obj.checkList.length==0)return ElMessage.warning(`请选择${msg}单!!`)
          
          if(obj.weigth<=0)return ElMessage.warning(`${msg}重量不能小于等于0!!`)
          $emit('onSubmit', obj,warehouseType.value)

          close()
    }catch(err){
      console.log(err);
    }
    
  } else if (key === '{clear}') { //键盘清空
    if(currentIndex.value==8){
      form.value['peel'] = ''
       // // 清空键盘之前的输入值
      keyboardRef.value.resetKeyboard('')
    }else if(!isWeight.value){
      form.value['weigth'] = ''
      keyboardRef.value.resetKeyboard('')
    }

  } else if (key === '{husk}') { //键盘去皮
    if(!isWeight.value)return
    form.value.weigth = 0
    // script.setZero()// 置零
  }else if(key=="{close}"){
    close()
  }
  
}

// 实时获取秤实际重量
// 获取数字
const getFloat = function (v) {
  if (typeof v == "string") {
    const str = v.split(/[\t\r\f\n\s]*/g).join("");
    var regEx = /[^\d|^\.|^\-]/g;
    const num = str.replace(regEx, "");
    return parseFloat(num);
  }
};
// 每200 刷新秤端值
const getWeight = () => {
  setTiem = setInterval(() => {
    const weight = script.getWeight();// getFloat(script.getWindowName())
    if (form.value.weigth !== weight) {
      form.value.weigth = weight;
    }
  }, 200);
  return setTiem;
};

// 关闭弹框
const close = () => {
  clearInterval(setTiem);
 
  dialogTableVisible.value = false
  // let val=isWeight.value?script.setEnumu('0',0)||0:0 //获取初始值
  form.value={
    weigth: 0,
    peel: 0,
    addImage: '',
    checked: false,
    returnImage:'',
  }
 // 停止监听
 script.stopSerialPortListerning()
}

// 清空数据
const clearData = () => {
  form.value = {
    weigth: 0,
    peel: 0,
    addImage: '',
    checked: false,
    returnImage:'',
  }
  clearInterval(setTiem);
  currentIndex.value=0
}
// 截取规格
const unitSplic=(unitName:string,isEnd:boolean=false,item:any)=> {
  if (!unitName) return "";
  // 过滤字符串中的数字
  const str = unitName.replace(/\d+/g, "");
  let strq = str.replace('.', "");//替换掉字符串中的小数点
  let arr = strq.split("*") || [];
  if(arr.length==0)return ""
  // 判断是否要取最后一个
  if(isEnd)return arr[arr.length-1]
  // 判断是否是调料
  if(item&&item.goodsIsSeasoning==1){
    if(arr.length>1)return arr[arr.length-2]
      return arr[arr.length-1]
  }
  if (arr.length>0) return arr[0];
  return "";
}

// 字典表查询取出最小单位
const getDictUnit=(unitName:string,orderNo:number=0)=> {
  const unitList = dictObj.value.all_unit_type;
  let weightData=['0','1','2','13','14']
    // 过滤出字典表中为计重单位的数据
    const dictData=unitList.filter(item=>weightData.includes(item.dictValue))||[]
    // 计件单位
    const dicList=dictData.map(item=>item.dictLabel)||[]
    console.log(dictData,dicList.includes(unitName),unitName);
    
    if(unitName=='斤')return `(${GetNumByUnit(orderNo,'g','j')}${unitName})`
    if(unitName&&dicList.includes(unitName))return `(${GetNumByUnit(orderNo,'g',unitName)}${unitName})`
    return ''
  // return 0;
}
// 获取单位的label
const getUnitLabel=(unitType:string,isWeight:boolean=false)=> {
  let weightData=['0','1','2','13','14']
  if(isWeight){
    return weightData.includes(unitType)
  }
  
  const unitList = dictObj.value.all_unit_type;
  // 过滤出字典表中为计重单位的数据
  const dictData=unitList.find(item=>item.dictValue==unitType)||{}
  if(dictData)return dictData.dictLabel
  return ''
}

// 查询是否有自定义容器
const getCustomContainer = () => {
  // warehouseType.value 1 出仓 0 入仓 2 退仓 3、4加工
  const configType=warehouseType.value==0?'add_warehouse_tare':warehouseType.value==1?'reduce_warehouse_tare':warehouseType.value!=2?'process_tare':""
   getUserConfigValue({configType,configKey:'scale_custom_container'}).then((res: any) => {
    const data = res.data||{};
    // 是否显示自定义容器
    let showCustom= data&&data.configValue==1?true:false;
    // 当前是否显示自定义容器
     currentTab.value=tabList.filter(item=>!showCustom?item!="自定义":true)

   })
}
defineExpose({
  open,
  close
})
</script>
<style  scoped>
>>> .el-input-group__append{
  /* background: transparent; */
  padding: 0 5px;
  box-shadow: none;

}
>>> .custom-input .el-input-group__append{
  background: transparent;
}
>>>.el-input-group{
 border: 1px solid var(--el-border-color) ;
  border-radius: var(--el-input-border-radius);
}
>>>.el-input__wrapper,>>>.el-input.is-disabled .el-input__wrapper{
  box-shadow: none;
}

.tabs-item{
  /* width: calc(100% / 4); */
  min-width: 68px;
  text-align: center;
  border: 1px solid #ccc;
  padding:  8px 0;
  cursor: pointer;
  border-radius: 3px;

}
.active{
  background: #06AC53;
  border-color: #06AC53;
  color: #fff;
}


</style>
<style>
 .scale-dialog .el-dialog__header .el-dialog__headerbtn{
  font-size: 30px ;
  height: auto;
}
.scale-dialog .el-dialog__header{
  border-bottom: 1px solid #ECECEC;
  margin: 0;
  padding-top: 10px;
}
.scale-dialog  .el-dialog--center .el-dialog__body{
  padding: 15px 16px 20px;
}
.scale-dialog .el-checkbox__input.is-checked .el-checkbox__inner{
  background: #06AC53;
  border-color: #06AC53;
  color: #06AC53;
}
.scale-dialog .el-checkbox__input.is-checked+.el-checkbox__label{
  color: #06AC53;

}
.scale-dialog .hg-theme-default .hg-button{
  background: #e8e7e7;
}
.scale-dialog .hg-theme-default .hg-functionBtn{
  background: #d3d2d3;
}
</style>
